module.exports = __webpack_public_path__ + "media/site/images/products/avisboard-screen-059cb03495051ccad9235437e6aeef2e.png";